import React, { useState } from 'react';
import {
  TrackerFeedbackConnectorApollo,
  useAppContext,
  useTranslator,
  useToast,
} from '@front-activerse/common-components';
import { Row, Col } from 'reactstrap';

const TrackerFeedback: React.FC<{ requestId: string }> = ({ requestId }) => {
  const { t } = useTranslator();
  const { toastError } = useToast();
  const {
    images: { thumbDownActiveIcon, thumbDownDefaultIcon, thumbUpActiveIcon, thumbUpDefaultIcon },
  } = useAppContext();

  const [feedbackType, setFeedbackType] = useState<'thumbDown' | 'thumbUp' | null>(null);

  const handleFeedback = async (
    type: 'thumbDown' | 'thumbUp',
    requestId: string,
    requestFeedback: (requestId: string, feedback: boolean) => Promise<any>
  ) => {
    const feedback = type === 'thumbUp';
    setFeedbackType(type);
    const response = await requestFeedback(requestId, feedback);
    if (response.__typename !== 'BasicMutationSuccess') {
      toastError();
    }
  };

  return (
    <TrackerFeedbackConnectorApollo>
      {({ requestFeedback }) => (
        <Row>
          <Col xs="12" md={{ size: 6, offset: 3 }}>
            <div className="d-flex justify-content-between align-items-center mt-xxl">
              <span className="description text-text-variant-color">
                {t('tracker.aiRecognitionVerificationQuestion')}
              </span>

              <div className="d-flex gap-1">
                <button
                  className={`feedback-button ${feedbackType === 'thumbUp' ? 'thumb-up' : ''}`}
                  onClick={() => handleFeedback('thumbUp', requestId, requestFeedback)}
                >
                  <img
                    src={feedbackType === 'thumbUp' ? thumbUpActiveIcon : thumbUpDefaultIcon}
                    alt="Thumb up"
                  />
                  {t('tracker.aiVerification.yes')}
                </button>
                <button
                  className={`feedback-button ${feedbackType === 'thumbDown' ? 'thumb-down' : ''}`}
                  onClick={() => handleFeedback('thumbDown', requestId, requestFeedback)}
                >
                  <img
                    src={feedbackType === 'thumbDown' ? thumbDownActiveIcon : thumbDownDefaultIcon}
                    alt="Thumb down"
                  />
                  {t('tracker.aiVerification.no')}
                </button>
              </div>
            </div>
          </Col>
        </Row>
      )}
    </TrackerFeedbackConnectorApollo>
  );
};

export default TrackerFeedback;
